import { render, staticRenderFns } from "./UserNameInfo.vue?vue&type=template&id=4ed7a8a5&"
import script from "./UserNameInfo.vue?vue&type=script&lang=ts&"
export * from "./UserNameInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports